import { FlexContainerLogic as FlexContainer } from './FlexContainer.logic'

export default FlexContainer
